import { render, staticRenderFns } from "./registerStep.vue?vue&type=template&id=beec4a62"
import script from "./registerStep.vue?vue&type=script&lang=js"
export * from "./registerStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports